import React from "react";
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="document-container">
        <header className="header-terms">
            <img src="https://customer-assets.emergentagent.com/job_57c7f0f2-1ce5-418b-8c85-4edaf17ae25c/artifacts/z4zwe4ra_FullLogo_NoBuffer.jpg" alt="Luxtansa Resorts Logo" className="logo" />
            <h1 className="document-title">Terms & Conditions</h1>
            <p className="document-subtitle">Hotel Stay Agreement</p>
        </header>

        <div className="info-box">
            <p><strong>Hotel Name:</strong> Luxtansa Resorts</p>
            <p><strong>Location:</strong> Tamil Nadu, India</p>
            <p><strong>Effective Date:</strong> 07 January 2026</p>
        </div>

        <div className="intro-text">
            <p>By confirming a reservation, entering the premises, or staying at Luxtansa Resorts ("Hotel"), you ("Guest") agree to these Terms & Conditions.</p>
        </div>

        <div className="section">
            <h2 className="section-title-terms"><span className="section-number">1</span>Booking & Confirmation</h2>
            <div className="section-content">
                <p>A booking is confirmed only after payment (full/partial as applicable) and issuance of a booking confirmation by the Hotel or an authorized booking partner.</p>
                <p>The Guest must provide a valid mobile number and email address for booking-related communication.</p>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-terms"><span className="section-number">2</span>Check-in / Check-out</h2>
            <div className="section-content">
                <div className="highlight-box time-info">
                    <div className="time-block">
                        <div className="time-label">Check-in Time</div>
                        <div className="time-value">12:00 PM (IST)</div>
                    </div>
                    <div className="time-block">
                        <div className="time-label">Check-out Time</div>
                        <div className="time-value">12:00 PM (IST) Next Day</div>
                    </div>
                </div>
                <p>Early check-in and late check-out are subject to availability and may attract additional charges.</p>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-terms"><span className="section-number">3</span>Guest Identification (KYC) — Mandatory</h2>
            <div className="section-content">
                <p>All guests must present valid government-issued photo ID at check-in.</p>
                <div className="highlight-box">
                    <p><strong>Accepted IDs include (as applicable):</strong></p>
                    <ul>
                        <li>Aadhaar</li>
                        <li>Passport</li>
                        <li>Driving License</li>
                        <li>Voter ID</li>
                    </ul>
                </div>
                <p>Foreign nationals must present Passport and valid Visa/OCI (as applicable).</p>
                <p>The name on the reservation should match the guest's ID. Failure to produce valid ID may result in denial of check-in (subject to applicable law and booking terms).</p>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-terms"><span className="section-number">4</span>Occupancy & Eligibility Policy</h2>
            <div className="section-content">
                <p>Room occupancy is limited as per the room category and safety norms.</p>
                <p>Extra person / extra bed is subject to availability and will be chargeable as per the Hotel's tariff.</p>
                <div className="warning-box">
                    <p><strong>Important:</strong> Unmarried couples are not allowed.</p>
                </div>
                <p>The Hotel reserves the right to verify eligibility at check-in and to deny check-in if this policy is not met (subject to applicable law and booking terms).</p>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-terms"><span className="section-number">5</span>Tariffs, Taxes & Payments</h2>
            <div className="section-content">
                <ul>
                    <li>Room rates may vary by season, demand, and availability.</li>
                    <li>The applicable final rate is the one shown/confirmed at the time of booking.</li>
                    <li>GST and other applicable taxes will be charged as per Government rules in force at the time of stay.</li>
                    <li>The Hotel may request a security deposit at check-in, refundable at checkout subject to room inspection and settlement of dues.</li>
                    <li>Payment modes may include cash (subject to legal limits), UPI, cards, and bank transfer (as enabled by the Hotel).</li>
                </ul>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-terms"><span className="section-number">6</span>Cancellation Policy — Moderate</h2>
            <div className="section-content">
                <p>Unless a different policy is clearly mentioned in your booking confirmation (for example, special packages, peak dates, or third-party portals), the following <strong>Moderate Cancellation Policy</strong> applies:</p>
                <div className="highlight-box">
                    <ul>
                        <li><strong>Free cancellation</strong> up to <strong>48 hours before check-in time (12:00 PM IST)</strong>.</li>
                        <li><strong>Cancellations made within 48 hours of check-in</strong> will be charged <strong>1 night's room tariff (plus applicable taxes)</strong>.</li>
                        <li><strong>No-show</strong> will be charged <strong>1 night's room tariff (plus applicable taxes)</strong> and the reservation may be cancelled for the remaining nights.</li>
                    </ul>
                </div>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-terms"><span className="section-number">7</span>Modification / Date Change</h2>
            <div className="section-content">
                <p>Date changes and booking modifications are subject to availability and rate differences.</p>
                <p>If modifications fall within the cancellation window, charges may apply as per Section 6.</p>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-terms"><span className="section-number">8</span>No Smoking Policy (Entire Premises)</h2>
            <div className="section-content">
                <div className="warning-box">
                    <p>Smoking is <strong>strictly prohibited</strong> within the entire premises of Luxtansa Resorts, including:</p>
                    <ul>
                        <li>Rooms</li>
                        <li>Balconies/Verandahs</li>
                        <li>Washrooms</li>
                        <li>Common areas</li>
                        <li>Outdoor spaces within the property boundary</li>
                    </ul>
                </div>
                <p>Any violation may result in a cleaning/deodorization fee and/or eviction without refund (where permitted by law), and/or action as per applicable laws.</p>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-terms"><span className="section-number">9</span>Pet Policy</h2>
            <div className="section-content">
                <p>No pets are allowed on the premises.</p>
                <p>The Hotel may deny check-in if a guest arrives with a pet.</p>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-terms"><span className="section-number">10</span>Zero Tolerance: Drugs & Illegal Substances</h2>
            <div className="section-content">
                <div className="warning-box">
                    <p>Possession, use, consumption, sale, or distribution of drugs / illegal substances is <strong>strictly prohibited</strong> anywhere within the Hotel premises.</p>
                </div>
                <p>If the Hotel reasonably believes a violation has occurred, the Hotel may:</p>
                <ul>
                    <li>Deny check-in or evict the guest immediately without refund (where permitted by law),</li>
                    <li>Recover any costs/damages resulting from the incident, and</li>
                    <li>File a complaint with local police / inform authorities, including Yelagiri Hills Police Station, as appropriate.</li>
                </ul>
                <p>The Hotel reserves the right to cooperate fully with law enforcement authorities as required.</p>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-terms"><span className="section-number">11</span>Visitor Policy</h2>
            <div className="section-content">
                <p>Only registered guests are permitted inside rooms.</p>
                <p>Visitors, if allowed, must register at reception with valid ID and comply with Hotel rules.</p>
                <p>The Hotel may restrict visitor entry at its discretion.</p>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-terms"><span className="section-number">12</span>Guest Conduct & Property Rules</h2>
            <div className="section-content">
                <p>Guests must maintain decorum and not create disturbance to other guests or staff.</p>
                <p>Illegal activities, violence, harassment, loud noise, vandalism, or misuse of property are strictly prohibited.</p>
                <p>The Hotel reserves the right to refuse service or request a guest to vacate for serious violations (subject to applicable law).</p>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-terms"><span className="section-number">13</span>Damages, Loss & Liability</h2>
            <div className="section-content">
                <p>Guests are responsible for any damage to Hotel property caused by them or their visitors.</p>
                <p>The Hotel may recover repair/replacement costs from the security deposit or by charging the guest.</p>
                <p>Guests should safeguard personal belongings. The Hotel is not responsible for loss due to guest negligence; liability, if any, is limited as per applicable law.</p>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-terms"><span className="section-number">14</span>Facilities, Services & Maintenance</h2>
            <div className="section-content">
                <p>Resort facilities (Wi-Fi, parking, pool, restaurant, activities, etc.) are subject to operational hours, safety rules, weather, and maintenance schedules.</p>
                <p>The Hotel may suspend or restrict amenities temporarily due to maintenance, safety, or regulatory requirements without prior notice.</p>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-terms"><span className="section-number">15</span>Force Majeure</h2>
            <div className="section-content">
                <p>The Hotel is not liable for delays, cancellations, or service limitations due to events beyond its control (including natural disasters, floods/cyclones, government restrictions, power/water interruptions, strikes, epidemics/pandemics, or other unforeseen circumstances).</p>
                <p>Any refund/credit will be handled as per Hotel policy and applicable law.</p>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-terms"><span className="section-number">16</span>Privacy & Data Use</h2>
            <div className="section-content">
                <p>Guest information is collected for booking, check-in compliance, and service delivery.</p>
                <p>The Hotel may share information with authorities where legally required.</p>
                <p>The Hotel will take reasonable steps to protect guest data.</p>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-terms"><span className="section-number">17</span>Governing Law & Jurisdiction</h2>
            <div className="section-content">
                <p>These Terms are governed by the laws of India.</p>
                <p>Any disputes shall be subject to the jurisdiction of the competent courts at <strong>Tirupattur, Tamil Nadu – 635601</strong>.</p>
            </div>
        </div>

        <div className="contact-section-terms">
            <h3>Contact Us</h3>
            <p style={{ marginBottom: "20px" }}>Luxtansa Resorts</p>
            <div className="contact-info">
                <div className="contact-item">
                    <div className="contact-label">Contact Person</div>
                    <div className="contact-value">Elango Kanakaraji</div>
                </div>
                <div className="contact-item">
                    <div className="contact-label">Phone</div>
                    <div className="contact-value">7358481281</div>
                </div>
                <div className="contact-item">
                    <div className="contact-label">Email</div>
                    <div className="contact-value">luxtansaresorts@gmail.com</div>
                </div>
            </div>
        </div>

        <div className="footer-terms">
            <p>RELAX, REFRESH, RECHARGE</p>
        </div>
    </div>
  );
};

export default TermsAndConditions;